import {SvgIcon, SvgIconProps} from "@mui/material";
import React from "react";

export const DataIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon sx={{fill: "none", strokeWidth: "1.6", ...props.sx}} viewBox="0 0 16 18">
        <path
            d="M15 3.4C15 4.72548 11.866 5.8 8 5.8C4.13401 5.8 1 4.72548 1 3.4M15 3.4C15 2.07452 11.866 1 8 1C4.13401 1 1 2.07452 1 3.4M15 3.4V14.6C15 15.928 11.8889 17 8 17C4.11111 17 1 15.928 1 14.6V3.4M15 9C15 10.328 11.8889 11.4 8 11.4C4.11111 11.4 1 10.328 1 9"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
);
